import { render, staticRenderFns } from "./DeletePopover.vue?vue&type=template&id=46cbd65a&"
import script from "./DeletePopover.vue?vue&type=script&lang=js&"
export * from "./DeletePopover.vue?vue&type=script&lang=js&"
import style0 from "./DeletePopover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports